var scope_0 = require('/Users/stacey/Local-Git-Repo/Fastrrr/10_Website/fastrrr-prod/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95afc7e3ece9fb4d4bcf6cede4a0d2c2.js').default;
var scope_1 = require('/Users/stacey/Local-Git-Repo/Fastrrr/10_Website/fastrrr-prod/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    